(function () {
  document.documentElement.classList.add('home-animate');

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.shopify-section').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -60px 0px' }
    );
    document.querySelectorAll('.shopify-section').forEach(function (el, i) {
      if (i === 0) return; // skip hero
      observer.observe(el);
    });
  } else {
    document.querySelectorAll('.shopify-section').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }
})();